import { FormikErrors, FormikTouched } from 'formik';
import React, { memo } from 'react';
import { SearchByFiscalCodeVM } from 'shell/view-models/search-anpr';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Grid } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { Typography } from '@mui/material';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersPersonSearch } from 'shell/constants/filters-person-search';

interface FilterFiscalCodeProps {
  open?: boolean;
  onOpenAccordion: (value: FiltersPersonSearch) => void;
  values?: SearchByFiscalCodeVM;
  onChange: (
    key: keyof SearchByFiscalCodeVM,
    value: SearchByFiscalCodeVM[keyof SearchByFiscalCodeVM]
  ) => void;
  onChangeValues: (object: SearchByFiscalCodeVM) => void;
  errors?: FormikErrors<SearchByFiscalCodeVM>;
  touched?: FormikTouched<SearchByFiscalCodeVM>;
}

const FilterFiscalCode = ({
  values,
  onChange,
  open,
  onOpenAccordion,
  errors,
  touched,
}: FilterFiscalCodeProps): React.ReactElement => {
  return (
    <Accordion
      expanded={open}
      onChange={() => {
        onOpenAccordion(FiltersPersonSearch.FiscalCode);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-filters-by-fiscal-code-data-content"
        id="panel-person-filters-by-fiscal-code-data-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Ricerca per codice fiscale</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} md={5}>
            <PmiTextField
              label="Codice Fiscale"
              id="fiscalCode"
              name="fiscalCode"
              fullWidth
              type="text"
              variant="outlined"
              value={values?.fiscalCode}
              inputProps={{
                maxLength: 16,
              }}
              onChange={(event) => {
                onChange(
                  'fiscalCode',
                  event.target.validity.valid ? event.target.value : values?.fiscalCode
                );
              }}
              error={touched?.fiscalCode && Boolean(errors?.fiscalCode)}
              helperText={errors?.fiscalCode}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

FilterFiscalCode.displayName = 'Filter by Fiscal Code Component';
const FilterSearchByFiscalCode = memo(FilterFiscalCode);
export default FilterSearchByFiscalCode;
